


import { useState } from "react";
import Config from "../../Config";

 


import Free from "./FreeE";
import Hour from "./HourE";
import HourEditE from "./HourEditE";
import ScheduleE from "./ScheduleE";
import Eat from "../emp/Eat";


 



function View(props)
{
    
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);
        //getData();
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    

    if(props.mainView.viewSelected == "free" || props.mainView.viewSelected == "view") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "hour") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "schedule") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "lunch") tab4 = tab4 + " selected";

    var subMenu = <div className="submenu">
        <div className={tab1} module="myJobs" view="free" id="" onClick={props.mainView.quickGo} >Urlopy</div>
        <div className={tab2} module="myJobs" view="hour" id="" onClick={props.mainView.quickGo} >Moje godziny</div>
        <div className={tab3}  module="myJobs" view="schedule" id="" onClick={props.mainView.quickGo} >Mój grafik</div>
        <div className={tab4}  module="myJobs" view="lunch" id="" onClick={props.mainView.quickGo} >Zamówienia na posiłki</div>
    </div>
 
 //

    if(props.mainView.viewSelected == 'free' || props.mainView.viewSelected == 'view')
    {
        document.title ="Urlopy"; 

        return (
            <div>                           
                {subMenu} 
                <Free  userData={props.userData}  mainView={props.mainView}  />
             </div>
        )
    }

    var is_mobile = props.mainView.isMobile();

    if(props.mainView.viewSelected == 'schedule')
    {   
        document.title ="Mój grafik"; 

        return (
            <div>                           
                {subMenu} 
                <ScheduleE  userData={props.userData}  mainView={props.mainView}  />
             </div>
        )
    }
    
    if(props.mainView.viewSelected == 'hour')
    {   
        document.title ="Moje godziny"; 

        return (
            <div>
                {subMenu} 
                <Hour  userData={props.userData} view='link'  mainView={props.mainView}  />
            </div>    
            )    
            
    }
 
    if(props.mainView.viewSelected == 'hour_add')
        {   
            document.title ="Moje godziny"; 
    
            return (
                <div>
                    {subMenu} 
                    <Hour  userData={props.userData} view='dialog'  mainView={props.mainView}  />
                </div>    
                )    
                
        }


  if(props.mainView.viewSelected == 'lunch')
        {   
            document.title ="Zamówienia i posiłki"; 
    
            return (
                <div>
                    {subMenu} 
                     <Eat  userData={props.userData}  mainView={props.mainView}  /> 
                </div>    
                )    
                
        }        
                

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default View;